import React, { Component } from 'react';
import { GoogleMap, LoadScript } from '@react-google-maps/api';


const SimpleMap = ({ center = { lat: 0, lng: 0 }, zoom = 13, items, height = 400, onClick, onLoad, onDragEnd, mapType = 'hybrid' }) => {
  const mapStyles = {
    height: height,
    width: "100%"
  };

  const defaultCenter = {
    lat: 41.3851,
    lng: 2.1734
  };

  return (
    <LoadScript googleMapsApiKey='AIzaSyAG4SVpzGlq7WL3hT-jwi0SXH5o3IUm6Ks'>
      <GoogleMap
        mapTypeId={mapType}
        onClick={onClick && onClick}
        onLoad={onLoad && onLoad}
        onDragEnd={onDragEnd && onDragEnd}
        mapContainerStyle={mapStyles}
        zoom={parseInt(zoom)}
        center={center.lat && center.lng ? { lat: parseFloat(center.lat), lng: parseFloat(center.lng) } : defaultCenter}
      >
        {items && items.map(el => el)}
      </GoogleMap>
    </LoadScript>
  )
};

export default SimpleMap;
